import { ScrollPosition } from './scroll-position';
import { ScrollRestorationMode } from './scroll-restoration-mode';

export class ScrollSnapshot {
  constructor(
    public restoration: ScrollRestorationMode = 'frameworkDefault',
    public position: ScrollPosition = { x: 0, y: 0 },
  ) {}
}
